import React from 'react';
import { XCircle, ArrowLeft, CreditCard } from 'lucide-react';
import { Button } from '../ui/Button';

interface SubscriptionCancelProps {
  onReturnToDashboard: () => void;
}

export const SubscriptionCancel: React.FC<SubscriptionCancelProps> = ({ onReturnToDashboard }) => {
  const handleTryAgain = () => {
    onReturnToDashboard();
    // The user can try subscribing again from the dashboard
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
          <div className="flex justify-center mb-6">
            <XCircle className="w-16 h-16 text-orange-500" />
          </div>
          
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-2">
            Subscription Cancelled
          </h1>
          
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            Your subscription setup was cancelled. No payment was processed and you can try again anytime.
          </p>

          <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4 mb-6">
            <h3 className="font-semibold text-blue-900 dark:text-blue-100 mb-2 flex items-center justify-center">
              <CreditCard className="w-4 h-4 mr-2" />
              What happens next?
            </h3>
            <div className="text-sm text-blue-800 dark:text-blue-200 space-y-1">
              <div>• No charges were made to your card</div>
              <div>• You can continue using your free trial</div>
              <div>• Subscribe anytime from your dashboard</div>
            </div>
          </div>

          <div className="space-y-3">
            <Button 
              onClick={handleTryAgain}
              className="w-full"
              rightIcon={<CreditCard size={16} />}
            >
              Try Subscribing Again
            </Button>
            
            <Button 
              onClick={onReturnToDashboard}
              variant="outline"
              className="w-full"
              leftIcon={<ArrowLeft size={16} />}
            >
              Return to Dashboard
            </Button>
          </div>

          <p className="text-xs text-gray-500 dark:text-gray-400 mt-6">
            Need help? Contact our support team anytime.
          </p>
        </div>
      </div>
    </div>
  );
}; 
 